import React from 'react';
import classNames from 'classnames';

type TickerProps = {
    data: {
        text: string;
        direction?: 'Left' | 'Right';
    };
};

function Ticker({ data }: TickerProps) {
    const { text, direction = 'Right' } = data;
    const textList = text.split(';');

    const classnames = {
        block: classNames({
            ticker: true,
            'ticker--reverse': direction !== 'Left',
            'ticker--slow': textList.length > 1,
        }),
    };

    const runningTrackRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    runningTrackRef.current?.classList.remove('is-on-pause');
                } else {
                    runningTrackRef.current?.classList.add('is-on-pause');
                }
            });
        });

        observer.observe(runningTrackRef.current!);

        return () => {
            observer.disconnect();
        };
    }, []);
    return (
        <div className={classnames.block}>
            <div className="ticker__track" ref={runningTrackRef}>
                {Array.from({ length: 50 }, (_, i) => textList[i % textList.length]).map(
                    (element, i) => {
                        return (
                            <span className="ticker__word" key={i}>
                                {element}
                            </span>
                        );
                    }
                )}
            </div>
        </div>
    );
}

export { Ticker };
